// extracted by mini-css-extract-plugin
module.exports = {"zIndexToolTip":"13380000","disabledLink":"styles_disabledLink__1RC4X"};